import { portalCustomizationZodSchema } from "@redotech/redo-customer-portal-common/portal-customization";
import * as z from "zod";

export const getPortalCustomization = {
  name: "getPortalCustomization" as const,
  input: z.object({}),
  output: z.object({
    customization: portalCustomizationZodSchema.nullable(),
    portalBuilderMigrated: z.boolean(),
  }),
};

export {
  portalCustomizationZodSchema,
  type PortalCustomization,
} from "@redotech/redo-customer-portal-common/portal-customization";
